const lazyRetry = function lazyRetry(componentImport: () => Promise<any>): Promise<any> {
  return new Promise((resolve, reject) => {
    const hasRefreshed = JSON.parse(window.sessionStorage.getItem('retry-lazy-refreshed') || 'false')

    let promiseHasEnded = false

    setTimeout(() => {
      if (!promiseHasEnded) {
        window.sessionStorage.setItem('retry-lazy-refreshed', 'true')
        console.log('Qlocx App refreshing view because of lazy load timeout')
        window.location.reload()
      }
    }, 7000)

    componentImport()
      .then((component: any) => {
        window.sessionStorage.setItem('retry-lazy-refreshed', 'false')
        resolve(component)
      })
      .catch((error: Error) => {
        if (!hasRefreshed) {
          window.sessionStorage.setItem('retry-lazy-refreshed', 'true')
          console.log('Qlocx App refreshing view because of lazy load error')

          setTimeout(() => {
            window.location.href = '/'
          }, 2000)
        } else {
          reject(error)
        }
      })
      .finally(() => {
        promiseHasEnded = true
      })
  })
}

export default lazyRetry
